<template>
  <q-layout
    class="dashboard-layout"
    :class="{ 'tw-border-t-4 tw-border-orange-500': isStagingEnvironment }"
  >
    <q-page-container>
      <q-page class="tw-flex tw-flex-col tw-overflow-hidden">
        <status-bar />

        <div class="tw-flex tw-flex-1 tw-flex-row tw-overflow-hidden">
          <Menu />
          <mobile-menu />

          <div
            class="tw-flex tw-h-full tw-flex-1 tw-flex-col tw-overflow-hidden"
          >
            <Header />

            <div id="scrollable-content" class="content">
              <slot />

              <countdown-authenticator
                v-if="showCountdownModal"
                :timer
                @reset-timer="resetTimer"
                @logout="logout"
              />

              <celebration-component
                v-if="celebrationVisible"
                :celebration-type="celebrationType"
              />

              <back-to-top />

              <nps-modal v-if="showNps" @close-modal="showNps = false" />
            </div>
          </div>
        </div>
      </q-page>
    </q-page-container>
  </q-layout>
</template>

<script setup>
import BackToTop from "components/global/BackToTop.vue";
import CelebrationComponent from "components/global/celebration/CelebrationComponent.vue";
import Header from "components/layout/Header.vue";
import Menu from "components/layout/Menu.vue";
import MobileMenu from "components/layout/MobileMenu.vue";
import StatusBar from "components/layout/StatusBar.vue";
import CountdownAuthenticator from "components/modals/auth/CountdownAuthenticator.vue";
import NpsModal from "components/modals/nps/NpsModal.vue";
import { isStagingEnvironment } from "composables/useHelpers";
import { useInteractionTimer } from "composables/useInteractionTimer";
import { storeToRefs } from "pinia";
import { useCelebrationStore } from "store/modules/celebrationStore.js";
import { onMounted, ref } from "vue";

const celebrationStore = useCelebrationStore();
const { celebrationVisible, celebrationType } = storeToRefs(celebrationStore);

// Inactivity logout
const { showCountdownModal, timer, resetTimer, logout } = useInteractionTimer();

// State
const showNps = ref(false);

onMounted(() => {
  showNps.value = localStorage.getItem("show_nps") !== "false";
});
</script>

<style lang="scss">
.dashboard-layout {
  background: #f8f8fa;

  &__staging {
    @apply tw-border-t-4 tw-border-orange-500;
  }
}
</style>
